module.exports = __webpack_public_path__ + "assets/img/noInfo.aaddc696.png";